// import libraries
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import axios from "axios";
import moment from "moment";
// import files
import { env } from "../../env";
// import components
import Layout from "../../layouts/Layout";
import ProfileLayout from "../../components/Profile/ProfileLayout";
import LoaderIcon from "../../components/Common/Icon/Loader";
import SchedulePopUp from "../../components/Profile/SchedulePopUp";
import WarningPopUp from "../../components/Profile/WarningPopUp";
import TaskComponent from "../../components/Profile/TaskComponent";
import { AuthContext } from "../../context";

const TaskIndex = () => {
    // variables
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    // boolean
    const [isLoader, setIsLoader] = useState(true);
    const [showSchedulePopUp, setShowSchedulePopUp] = useState(false);
    const [showWarningPopUp, setShowWarningPopUp] = useState(false);
    // list data
    const [visitTypeList, setVisitTypeList] = useState([]);
    // data
    const storedVisitData = localStorage.getItem('visit');
    const initialVisitData = storedVisitData ? JSON.parse(storedVisitData) : {};
    const [visitTypeData, setVisitTypeData] = useState(initialVisitData);
    const [customerData, setCustomerData] = useState({});
    const [ipData, setIpData] = useState({});
    const [userTaskList, setUserTaskList] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    // pagination
    const [rowCurrentTaskPage, setCurrentTaskPage] = useState(0);
    const [rowsPerTaskPage, setRowsPerTaskPage] = useState(50);
    const requestData = {
        "customername": customerData.name ? customerData.name : "",
        "fromDate": "",
        "paging_offset": rowCurrentTaskPage,
        "recordLimit": rowsPerTaskPage,
        "sortByFromDateASC": false,
        "sortByFromDateDESC": false,
        "sortByNameASC": false,
        "sortByNameDESC": false,
        "sortByToDateASC": false,
        "sortByToDateDESC": false,
        "statusName": "",
        "taskName": "",
        "toDate": ""
    };

    useEffect(() => {
        const fetchData = async () => {
            await getCustomerDataApi(baseUrl, token);
            await getVisitTypeListApi(baseUrl, token);
        };
        fetchData();
    }, [baseUrl, token]);

    const handleTabCheckDataFromChild = (data) => {
        if((visitTypeData && visitTypeData.visitId) && data.tab === 'profile') {
            setShowWarningPopUp(!showWarningPopUp)
        } else {
            if(data.link === '/logout') {
                authContext.logout();
            } else {
                navigate(data.link);
            }
            localStorage.removeItem("profile_tab");
        }
    };
    const handlePageChange = (data) => {
        if((visitTypeData && visitTypeData.visitId)) {
            setShowWarningPopUp(!showWarningPopUp)
        } else {
            navigate(data);
        }  
    };
    // api's
    const getVisitTypeListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/OfflineSync/GetCustomerVisitType`,{ headers })
        .then((response) => {
            setVisitTypeList(response.data);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getIpJson = async () => {
        try {
            const response = await axios.get("https://ipapi.co/json/", {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
            });
            setIpData(response.data);
        } catch (error) {
            console.error("Error fetching IP data:", error);
        }
    };
    const getUserTaskListApi = async(url, token, data) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+`/api/Task/GetUserTaskList`, data, { headers })
        .then((response) => {
            setUserTaskList(response.data);
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getCustomerDataApi = async (url, token) => {
        await axios.post(url+"/api/Customer/GetCustomerDetail", {customerid: id},{ 
            headers: {
                "Content-Type" : "multipart/form-data",
                "Authorization" : `Bearer ${token}`
            }
        }).then((response) => {
            const customer = response.data[0];
            setCustomerData(customer);
            const dataRequestOld = {
                "customername": customer.name,
                "fromDate": "",
                "paging_offset": rowCurrentTaskPage,
                "recordLimit": rowsPerTaskPage,
                "sortByFromDateASC": false,
                "sortByFromDateDESC": false,
                "sortByNameASC": false,
                "sortByNameDESC": false,
                "sortByToDateASC": false,
                "sortByToDateDESC": false,
                "statusName": "",
                "taskName": "",
                "toDate": ""
            };
            setCustomerData(customer);
            getUserTaskListApi(url, token, dataRequestOld);
            getIpJson();
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    
    // handle functions
    const handleOpenSchedulePopUp = (data) => {
        if(data === 'start') {
            setShowSchedulePopUp(!showSchedulePopUp)
        } else {
            setVisitTypeData({});
        }
    };
    const handleVisitResponseDataFromChild = (data) => {
        setVisitTypeData(data);
        setShowSchedulePopUp(!showSchedulePopUp);
    };
    const handleWarningPopUpDataFromChild = (data) => {
        setShowWarningPopUp(!showWarningPopUp);
        if(data === 'complete') {
            setVisitTypeData({});
        }
    };

    return (
        <div className="relative">
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}>
                <div className="relative">
                    <ProfileLayout page={"create-task"} customerData={customerData} visitTypeData={visitTypeData} sendOpenSchedulePopUp={handleOpenSchedulePopUp} sendPageChange={handlePageChange} />
                    { isLoader
                        ?
                            <LoaderIcon />
                        :
                        <div className="space-y-2 sm:space-y-4">
                            <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-4">
                                <div className="grid grid-cols-8 gap-4 items-center">
                                    <div className="col-span-6 sm:col-span-4 sm:space-y-2">
                                        <div>
                                            <h1 className="font-semibold lg:text-lg">{customerData.name}</h1>
                                        </div>
                                        <div className="font-normal text-xs lg:text-sm text-gray-dark capitalize">
                                            { t('customer code') }: <span className="text-black">{customerData.code}</span>
                                        </div>
                                        {customerData.address ? 
                                            <div className="hidden sm:flex items-center text-sm">
                                                <div className="flex">
                                                    <img src="../../../assets/icons/location.svg" alt="mail" />
                                                    <div className="text-gray-dark ml-1">{customerData.address}</div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </div>
                                    <div className="col-span-2 sm:col-span-4 flex justify-end space-x-3">
                                        <div className="bg-gray-dark3 rounded-lg p-1.5 lg:p-3 flex items-center space-x-1 text-xs sm:text-[10px] lg:text-sm">
                                            <img className="w-4 h-4" src="../../assets/icons/profile/calendar.svg" alt="calendar" />
                                            <span className="capitalize">{t('last visit date')}: <strong>{customerData.lastVisitedDate ? moment(customerData.lastVisitedDate).format('LL') : '--' }</strong></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <TaskComponent isActive={customerData.isActive} customerId={id} userTaskList={userTaskList} />
                        </div>
                    }
                </div>
            </Layout>
            {/* common */}
            {showSchedulePopUp && <SchedulePopUp customerId={id} ipData={ipData} visitTypeList={visitTypeList} sendSchedulePopUpDataFromChild={handleOpenSchedulePopUp} sendVisitResponseDataFromChild={handleVisitResponseDataFromChild} />}
            {showWarningPopUp && <WarningPopUp customerId={id} visitTypeData={visitTypeData} sendWarningPopUpDataFromChild={handleWarningPopUpDataFromChild} /> }
        </div>
    )
}

export default TaskIndex;